import { creatorbase } from '@round/api';

const REPORT_CAMPAIGNS_PAGE_SIZE = 1000;

export function getReportCampaignsListParams(reportId: string, platform: creatorbase.Platform) {
    return {
        report_id: reportId,
        platform,
        page_size: REPORT_CAMPAIGNS_PAGE_SIZE,
        ordering: 'report-platform-order',
    } as const;
}
